import { connect } from 'react-redux'
import { RootState } from '../../../store'
import { loggedUserImpersonatePermissions } from '../../../store/ui/adminUsers'
import { PatientForm } from './PatientForm.component'
import { PatientFormStoreProps } from './PatientForm.model'
import { enabledFeaturesPreferencesSelector } from '../../../store/domain/me'
import { addError } from '../../../store/message'

const mapStateToProps = (state: RootState): PatientFormStoreProps => ({
  impersonatePermissions: loggedUserImpersonatePermissions(state),
  enabledFeatures: enabledFeaturesPreferencesSelector(state),
})
const mapDispatchToProps = {
  addError,
}
const withConnect = connect(mapStateToProps, mapDispatchToProps)(PatientForm)
export { withConnect as PatientForm }
